(function () {
    'use strict';

    angular
        .module('app')
        .controller('PromoController', PromoController);

    PromoController.$inject = ['$http', '$state', '$stateParams', '$scope', '$rootScope', 'dateParser'];

    function PromoController($http, $state, $stateParams, $scope, $rootScope, dateParser) {
        const vm = this;
        vm.copyLink = copyLink;

        vm.$onInit = function () {
            $rootScope.header_inverted = true;
            $rootScope.on_dashboard = false;
            $rootScope.dark_text_header = true;

            getConcert();
        }

        $scope.$on('$destroy', function () {

        });

        function copyLink() {
            navigator.clipboard.writeText(vm.concert_link);
            vm.link_copied = 1;
        }

        function getConcert() { //Get data about the concert with the concert-API
            return $http.get('api/concerts/' + $stateParams.concert_slug + '/')
                .then(function (response) {
                    vm.concert = response.data;
                    vm.concert_link = response.data.concert_link;
                    vm.concert_link_da = response.data.concert_link_da;
                    if($stateParams.language == 'da'){
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link_da;
                    } else if ($stateParams.language == 'en') {
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.concert.concert_name + " - Be My Concert" +
                                    "&body=" + vm.concert_link;
                    }


                    if (vm.concert.concert_deleted_at > '') {
                        return $state.go('item_deleted');
                    }

                    vm.concert.concert_start_time = dateParser.parseDate(vm.concert.concert_start_time);
                    vm.concert.concert_end_time = dateParser.parseDate(vm.concert.concert_end_time);
                    vm.concert.concert_door_time = dateParser.parseDate(vm.concert.concert_door_time);
                });
        }
    }
})();
